<template>
  <div class="filters-mast">
    <!-- This feels like a daunting task, to revisit later. -->
  </div>
</template>
<script>
export default {
  props: '',
  data() {
    return {};
  }
};
</script>